// NOTICE: KAPTION-INTEGRATION
// team-location.SETTINGS.2 — option lists + pure helpers for the settings page.
export const MODES = ['off', 'optional', 'mandatory'];
export const PRECISIONS = ['precise', 'approximate'];
export const WHENS = ['online', 'working_hours', 'always'];
export const INTERVALS = [30, 60, 300];
export const RETENTIONS = [7, 30, 90];

const EDITABLE = [
  'mode',
  'precision',
  'when',
  'interval_seconds',
  'retention_days',
];

export function isDirty(form, saved) {
  if (!form || !saved) return false;
  return EDITABLE.some(key => String(form[key]) !== String(saved[key]));
}

const BASE = 'KAPTION_PLATFORM.TEAM_LOCATION.SETTINGS.AUDIENCE';

/** Human sentence for the tracking permission scope ("who is asked"). */
export function audienceSummary(audience, { t, teams = [], agents = [] }) {
  if (!audience) return '';
  const names = (ids, list) =>
    ids
      .map(id => list.find(item => item.id === id)?.name)
      .filter(Boolean)
      .join(', ');

  switch (audience.mode) {
    case 'everyone':
      return t(`${BASE}.EVERYONE`);
    case 'admins_only':
      return t(`${BASE}.ADMINS_ONLY`);
    case 'teams':
      return t(`${BASE}.TEAMS`, {
        names: names(audience.team_ids || [], teams) || '—',
      });
    case 'members':
      return t(`${BASE}.MEMBERS`, {
        names: names(audience.user_ids || [], agents) || '—',
      });
    default:
      return t(`${BASE}.OFF`);
  }
}

const PREVIEW = 'KAPTION_PLATFORM.TEAM_LOCATION.SETTINGS.PREVIEW';
const WHEN_KEYS = {
  online: 'ONLINE',
  working_hours: 'WORKING_HOURS',
  always: 'ALWAYS',
};

/**
 * team-location.EXPLAINER.1 — what the phone shows, in the phone's order, so
 * the preview matches it word for word (mobile: composeExplainer in
 * src/kaption-team-location/teamLocationCopy.ts):
 *   title  — the server notice title
 *   [Android] Google Play's prominent-disclosure sentence (always added)
 *   body   — the server notice body
 *   buttons — the phone's labels; "Not now" only when optional
 */
export function phonePreview({
  explainer,
  platform,
  mode,
  when,
  accountName,
  t,
}) {
  const android = platform === 'android';
  const mandatory = mode === 'mandatory';
  const buttonKey = `${android ? 'ANDROID' : 'IOS'}_${mandatory ? 'MANDATORY' : 'OPTIONAL'}`;
  return {
    title: explainer?.title || '',
    disclosure: android
      ? t(`${PREVIEW}.ANDROID_DISCLOSURE`, {
          when: t(`${PREVIEW}.ANDROID_WHEN.${WHEN_KEYS[when] || 'ONLINE'}`),
          account: accountName,
        })
      : null,
    body: explainer?.body || '',
    primary: t(`${PREVIEW}.BUTTONS.${buttonKey}`),
    secondary: mandatory ? null : t(`${PREVIEW}.NOT_NOW`),
  };
}
